import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { API_HANDLERS } from 'api/apiHandlers';
import { alert } from 'components';

export function useUpdateFolderMutation() {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  const { mutateAsync: updateFolderMutation, isLoading } = useMutation(
    ({ id, name }: { id: string; name: string }) => API_HANDLERS.FOLDERS.UPDATE(id, { name }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['folders']);
        alert.success(t('toasts.folder.success.edit'));
      },
    },
  );

  return { updateFolderMutation, isLoading };
}
